enum BoardSource {
  AmericanBoardofMedicalSpecialties = 'AmericanBoardofMedicalSpecialties',
  NationalBoardforCertifiedCounselors = 'NationalBoardforCertifiedCounselors',
  AmericanBoardofClinicalSocialWork = 'AmericanBoardofClinicalSocialWork',
  AmericanSpeechLanguageHearingAssociation = 'AmericanSpeechLanguageHearingAssociation',
  AmericanNursesCredentialingCenter = 'AmericanNursesCredentialingCenter',
  AmericanAcademyofNursePractitioners = 'AmericanAcademyofNursePractitioners',
  AmericanOsteopathicAssociation = 'AmericanOsteopathicAssociation',
  AmericanMedicalAssociation = 'AmericanMedicalAssociation',
  NationalBoardofCertificationandRecertificationforNurseAnesthetists = 'NationalBoardofCertificationandRecertificationforNurseAnesthetists',
  AmericanAssociationofCriticalCareNurses = 'AmericanAssociationofCriticalCareNurses',
  AmericanMidwiferyCertificationBoard = 'AmericanMidwiferyCertificationBoard',
  AmericanBoardofPodiatricMedicine = 'AmericanBoardofPodiatricMedicine',
  AmericanBoardofOralImplantology = 'AmericanBoardofOralImplantology',
  AmericanBoardofOralMedicine = 'AmericanBoardofOralMedicine',
  AmericanBoardofOrofacialPain = 'AmericanBoardofOrofacialPain',
  AmericanDentalBoardofAnesthesiology = 'AmericanDentalBoardofAnesthesiology',
  AmericanBoardofDentalPublicHealth = 'AmericanBoardofDentalPublicHealth',
  AmericanBoardofPediatricDentistry = 'AmericanBoardofPediatricDentistry',
  AmericanBoardofPeriodontology = 'AmericanBoardofPeriodontology',
  AmericanBoardofInternalMedicine = 'AmericanBoardofInternalMedicine',
  NationalCommissiononCertificationofPhysicianAssistants = 'NationalCommissiononCertificationofPhysicianAssistants',
  AmericanBoardofAllergyandImmunology = 'AmericanBoardofAllergyandImmunology',
  AmericanBoardofAnesthesiology = 'AmericanBoardofAnesthesiology',
  AmericanBoardofColonandRectalSurgery = 'AmericanBoardofColonandRectalSurgery',
  AmericanBoardofDermatology = 'AmericanBoardofDermatology',
  AmericanBoardofEmergencyMedicine = 'AmericanBoardofEmergencyMedicine',
  AmericanBoardofFamilyMedicine = 'AmericanBoardofFamilyMedicine',
  AmericanBoardofGeneticsandGenomics = 'AmericanBoardofGeneticsandGenomics',
  AmericanBoardofNeurologicalSurgery = 'AmericanBoardofNeurologicalSurgery',
  AmericanBoardofNuclearMedicine = 'AmericanBoardofNuclearMedicine',
  AmericanBoardofObstetricsandGynecology = 'AmericanBoardofObstetricsandGynecology',
  AmericanBoardofOphthalmology = 'AmericanBoardofOphthalmology',
  AmericanBoardofOrthopaedicSurgery = 'AmericanBoardofOrthopaedicSurgery',
  AmericanBoardofOtolaryngologyHeadandNeckSurgery = 'AmericanBoardofOtolaryngologyHeadandNeckSurgery',
  AmericanBoardofPathology = 'AmericanBoardofPathology',
  AmericanBoardofPediatrics = 'AmericanBoardofPediatrics',
  AmericanBoardofPhysicalMedicineandRehabilitation = 'AmericanBoardofPhysicalMedicineandRehabilitation',
  AmericanBoardofPlasticSurgery = 'AmericanBoardofPlasticSurgery',
  AmericanBoardofPreventiveMedicine = 'AmericanBoardofPreventiveMedicine',
  AmericanBoardofProfessionalPsychology = 'AmericanBoardofProfessionalPsychology',
  AmericanBoardofPsychiatryandNeurology = 'AmericanBoardofPsychiatryandNeurology',
  AmericanBoardofRadiology = 'AmericanBoardofRadiology',
  AmericanBoardofSurgery = 'AmericanBoardofSurgery',
  AmericanBoardofThoracicSurgery = 'AmericanBoardofThoracicSurgery',
  AmericanBoardofUrology = 'AmericanBoardofUrology',
  AmericanOptometricAssociation = 'AmericanOptometricAssociation',
  AssociationofSocialWorkBoards = 'AssociationofSocialWorkBoards',
  AmericanBoardofFootandAnkleSurgery = 'AmericanBoardofFootandAnkleSurgery',
  AmericanBoardofOralandMaxillofacialPathology = 'AmericanBoardofOralandMaxillofacialPathology',
  AmericanBoardofOralandMaxillofacialSurgery = 'AmericanBoardofOralandMaxillofacialSurgery',
  AmericanBoardofOrthodontics = 'AmericanBoardofOrthodontics',
  AmericanBoardofEndodontics = 'AmericanBoardofEndodontics',
  AmericanBoardofProsthodontics = 'AmericanBoardofProsthodontics',
  NationalBoardforCertificationinOccupationalTherapy = 'NationalBoardforCertificationinOccupationalTherapy',
  BehaviorAnalystCertificationBoard = 'BehaviorAnalystCertificationBoard',
  InternationalBoardofLactationConsultantExaminers = 'InternationalBoardofLactationConsultantExaminers',
  PediatricNursingCertification = 'PediatricNursingCertification',
  BoardOfPharmacySpecialties = 'BoardOfPharmacySpecialties',
  CommissionOnDieteticRegistration = 'CommissionOnDieteticRegistration',
  NationalCertificationCommissionforAcupunctureandOrientalMedicine = 'NationalCertificationCommissionforAcupunctureandOrientalMedicine',
  AmericanBoardofOralandMaxillofacialRadiology = 'AmericanBoardofOralandMaxillofacialRadiology',
  AmericanBoardofGeneralDentistry = 'AmericanBoardofGeneralDentistry',
  NationalAssociationofSchoolPsychologists = 'NationalAssociationofSchoolPsychologists',
  NationalPhlebotomyAssociation = 'NationalPhlebotomyAssociation',
  NationalCenterforCompetencyTesting = 'NationalCenterforCompetencyTesting',
  AmericanRegistryofRadiologyTechnologists = 'AmericanRegistryofRadiologyTechnologists',
  DentalAssistingNationalBoard = 'DentalAssistingNationalBoard',
  AmericanMedicalCertificationAssociation = 'AmericanMedicalCertificationAssociation',
  AmericanRegistryforDiagnosticMedicalSonography = 'AmericanRegistryforDiagnosticMedicalSonography',
  AmericanBoardofAddictionMedicine = 'AmericanBoardofAddictionMedicine',
  NationalCertificationCorporation = 'NationalCertificationCorporation',
  AmericanBoardOfObesityMedicine = 'AmericanBoardOfObesityMedicine',
  AmericanAcademyOfHIVMedicine = 'AmericanAcademyOfHIVMedicine',
  NationalCommissionForCertificationOfAnesthesiologistAssistants = 'NationalCommissionForCertificationOfAnesthesiologistAssistants',
  AmericanBoardOfCardiovascularMedicine = 'AmericanBoardOfCardiovascularMedicine',
  AmericanBoardofMultipleSpecialtiesinPodiatry = 'AmericanBoardofMultipleSpecialtiesinPodiatry',
  NationalBoardOfPhysiciansAndSurgeons = 'NationalBoardOfPhysiciansAndSurgeons',
  OncologyNursingCertificationCorporation = 'OncologyNursingCertificationCorporation',
}

export default BoardSource;
